export function formatCurrency(number: number) {
  const lang = localStorage.getItem("lang");
  // Chuyển số thành chuỗi và chia thành các phần sau mỗi 3 chữ số từ bên phải
  let parts = number?.toString().split(".") || ("" as any);
  if (parts) {
    parts[0] = parts[0].replace(
      /\B(?=(\d{3})+(?!\d))/g,
      lang === "en" ? "," : "."
    );
    // Nếu có phần thập phân thì nối lại sau phần nguyên
    return parts.join(",");
  }
  return "";
}

export function encryptData(data: string) {
  const randomPrefix = Math.random().toString(36).substring(2, 6);
  const randomSuffix = Math.random().toString(36).substring(2, 6);

  // Concatenate the random characters with the original data
  const encryptedData =
    randomPrefix + btoa(JSON.stringify(data)) + randomSuffix;
  return encryptedData;
}

export function decryptData(data: string) {
  // Get the original data by removing the random characters
  const encryptedData = data.substring(4, data.length - 4);
  const decryptData = atob(encryptedData);
  return decryptData;
}

export function setCookie(data: any, name: string) {
  var now = new Date();
  var time = now.getTime();
  var expireTime = time + (name === "payment_url" ? 3600000 : 900000); // 60 minutes | 15 minutes
  now.setTime(expireTime);

  const encryptedData = encryptData(data);
  document.cookie = `${name}=${encryptedData};expires='${now.toUTCString()}';path=/`;
}

export function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts?.length === 2) {
    const string = parts?.pop()?.split(";")?.shift();
    if (string) {
      const decryptedData = decryptData(string);
      return JSON.parse(decryptedData);
    }
  }
  return null;
}

export function deleteCookie(name: string) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
}

export function deleteAllCookies() {
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
  }
}

// LOCAL STORAGE
export const setLocalStorage = (name, data) => {
  const encryptedData = encryptData(data);
  localStorage?.setItem(name, encryptedData);
};

export const getLocalStorage = (name) => {
  const data = localStorage?.getItem(name);
  if (data) {
    const decryptedData = decryptData(data);
    return JSON.parse(decryptedData);
  }
  return null;
};

export const removeLocalStorage = (name) => {
  localStorage?.removeItem(name);
};

export const removeAllLocalStorages = () => {
  var lang = localStorage?.getItem("lang");
  localStorage?.clear();
  if (lang) {
    localStorage?.setItem("lang", lang);
  }
};
